import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "./storage";
import { uploadUrl } from "./DealImage";
const VisitRetailer = () => {
  const { type, id } = useParams();

  const [displayName, setDisplayName] = useState("");
  const [displayLogo, setDisplayLogo] = useState("");
  const [trackText, setTrackText] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [countdown, setCountdown] = useState(3);
  const hasCalledRef = useRef(false);
  const [expired, setExpired] = useState(false);
const [logoFailed, setLogoFailed] = useState(false);

  useEffect(() => {
    if (hasCalledRef.current) return;
    hasCalledRef.current = true;

    const run = async () => {
      const token = secureLocalStorage.getItem("n_token");
      if (!token) {
        window.location.href = "/login";
        return;
      }

      const endpoint = `${process.env.REACT_APP_API}website/track-click/${type}/${id}`;

      try {
        const { data } = await axios.post(
          endpoint,
          {},
          { headers: { token } }
        );

        if (data?.success) {
          setDisplayName(data.name);
          setDisplayLogo(data.logo || "");
          setTrackText(`${data.trackTime} ${data.trackUnit}`);
          setRedirectUrl(data.redirectUrl);

          let secondsLeft = 3;
          const countdownInterval = setInterval(() => {
            secondsLeft -= 1;
            setCountdown(secondsLeft);
            if (secondsLeft <= 0) clearInterval(countdownInterval);
          }, 1000);

          setTimeout(() => {
            window.location.href = data.redirectUrl;
          }, 3000);
        } else {
          setError(true);
        }
    } catch (e) {
  console.error(e);
  const status = e.response?.status;
  const serverMsg = e.response?.data?.message;

  if (status === 401) {
    setMessage(
      e.response?.data?.msg ||
      "Your session has expired. Redirecting to login..."
    );
    secureLocalStorage.clear();
    setTimeout(() => {
      window.location.href = "/login";
    }, 2000);
    return;
  }

  // The deal ended after the page was opened (backend sends 410)
  if (status === 410 || e.response?.data?.expired) {
    setExpired(true);
    return;
  }

  // Show the server's message for normal (4xx) errors, a generic one otherwise
  setMessage(status && status < 500 && serverMsg ? serverMsg : "");
  setError(true);
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [id, type]);
if (expired) {
  return (
    <div style={styles.pageWrapper}>
      <div style={styles.card}>
        <div style={{ ...styles.iconCircle, background: "#9ca3af", boxShadow: "none" }}>
          <span style={styles.countdownNumber}>!</span>
        </div>
        <h2 style={styles.title}>This deal has expired</h2>
        <p style={styles.subtitle}>
          Sorry, this offer is no longer available. Check out our other live deals instead.
        </p>
        <a href="/flash-deals" style={styles.primaryBtn}>View live deals</a>
        <div style={{ marginTop: "16px" }}>
          <a href="/" style={styles.clickHereLink}>Back to home</a>
        </div>
      </div>
    </div>
  );
}
  if (error || message) {
    if (loading) {
  return (
    <div style={styles.pageWrapper}>
      <div style={styles.card}>
        <p style={{ color: "#666", margin: 0 }}>Preparing your link...</p>
      </div>
    </div>
  );
}
    return (
      <div style={styles.pageWrapper}>
        <div
          style={{
            background: "#fff",
            padding: "20px",
            borderRadius: "10px",
            textAlign: "center",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
          }}
        >
          <p
            style={{
              color: error ? "#c0392b" : "#ff6b00",
              fontSize: "16px",
              fontWeight: "600"
            }}
          >
            {message || "Something went wrong while redirecting. Please try again."}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.pageWrapper}>
      <div style={styles.card}>
        <div style={styles.iconCircle}>
          <span style={styles.countdownNumber}>{countdown > 0 ? countdown : "✓"}</span>
        </div>

        <h2 style={styles.title}>You're all set!</h2>

        {!loading && (
          <p style={styles.subtitle}>
            Continue shopping at {displayName}. Your cashback will be
            credited to your CashKaroNa account within {trackText}.
          </p>
        )}

        <div style={styles.logoRow}>
          <div style={styles.logoBox}>
            <img
              src="/assets/images/logo/cashkaro.png"
              alt="CashKaroNa"
              style={styles.brandLogoImg}
            />
          </div>

          <div style={styles.connector}>
            <span className="ck-dot ck-dot1"></span>
            <span className="ck-dot ck-dot2"></span>
            <span className="ck-dot ck-dot3"></span>
          </div>

          <div style={styles.logoBox}>
           {displayLogo && !logoFailed ? (
  <img
    src={uploadUrl(displayLogo)}
    alt={displayName}
    style={styles.storeLogoImg}
    onError={() => setLogoFailed(true)}
  />
) : (
  <span style={styles.storeNameFallback}>{displayName}</span>
)}
          </div>
        </div>

        <hr style={styles.divider} />

        <p style={styles.footerText}>
          Redirecting in {countdown > 0 ? `${countdown}s` : "..."} — not
          working?{" "}
          {redirectUrl ? (
            <a href={redirectUrl} style={styles.clickHereLink}>
              Click here
            </a>
          ) : (
            "wait a moment"
          )}
        </p>
      </div>

      <style>{`
        .ck-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #ff7a1a;
          margin: 0 3px;
          display: inline-block;
          animation: ckMove 1.2s ease-in-out infinite;
        }
        .ck-dot1 { animation-delay: 0s; }
        .ck-dot2 { animation-delay: 0.2s; }
        .ck-dot3 { animation-delay: 0.4s; }
        @keyframes ckMove {
          0%, 100% { transform: translateY(0px); opacity: 0.4; }
          50% { transform: translateY(-6px); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

const styles = {
  pageWrapper: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fafafa",
    padding: "20px",
  },
  card: {
    maxWidth: "550px",
    width: "100%",
    textAlign: "center",
    border: "1px solid #eee",
    borderRadius: "16px",
    padding: "50px 40px",
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
    background: "#fff",
  },
  iconCircle: {
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #ff7a1a, #ff4b2b)",
    color: "#fff",
    fontSize: "28px",
    fontWeight: "700",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 25px",
    boxShadow: "0 6px 16px rgba(255, 90, 31, 0.35)",
  },
  countdownNumber: {
    lineHeight: 1,
  },
  title: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#1a1a2e",
    marginBottom: "15px",
  },
  subtitle: {
    color: "#666",
    fontSize: "15px",
    lineHeight: "1.6",
    marginBottom: "35px",
  },
  logoRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "18px",
    marginBottom: "20px",
  },
  logoBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "100px",
  },
  brandLogoImg: {
    maxWidth: "140px",
    maxHeight: "52px",
    objectFit: "contain",
  },
  connector: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "50px",
  },
  storeLogoImg: {
    maxWidth: "100px",
    maxHeight: "50px",
    objectFit: "contain",
  },
  storeNameFallback: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#333",
  },
  divider: {
    border: "none",
    borderTop: "1px solid #eee",
    margin: "25px 0",
  },
  footerText: {
    color: "#888",
    fontSize: "14px",
  },
  clickHereLink: {
    color: "#ff4b2b",
    textDecoration: "underline",
    fontWeight: "600",
  },
  primaryBtn: {
  display: "inline-block",
  padding: "10px 28px",
  borderRadius: "30px",
  background: "linear-gradient(135deg, #ff4b2b, #c01e12)",
  color: "#fff",
  fontWeight: "700",
  textDecoration: "none",
},
};

export default VisitRetailer;